<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}} esg-interior-description-widget" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="red-line">
        <ng-container *ngIf="editMode">
          <td colspan="1">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('esgExteriorDescription')"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
          </td>
        </ng-container>
        <td [attr.colspan]="(editMode?30:34)"><widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'esgExteriorDescription.labelTitle' | rdTranslate}}</widget-value></td>
      </tr>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_esg_exterior_description_topics'" [editMode]="editMode" [rows]="rows" [leftColspan]="17" [rightColspan]="17" [data]="widgetData" [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$" [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$" [moveCurrentRowDown]="moveCurrentRowDown$"
                              (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
        <table class="lettable-area-table cellspacing-0 cellpadding-0" aria-hidden="true">
          <thead>
            <tr class="totalAreaRow">
              <th scope="col" class="textAlignLeft">{{'esgExteriorDescription.labelTotalArea' | rdTranslate}}</th>
              <th scope="col">
                <widget-value [align]="'right'">{{widgetData.lettableArea.split(' ')[0] | rdLocalizedNumber:0}} {{widgetData.lettableArea.split(' ')[1]}}</widget-value>
              </th>
              <th scope="col">&nbsp;</th>
              <th scope="col">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of widgetData['areaPerUsage']; let i = index;">
              <tr>
                <td>
                  <widget-value [align]="'left'">{{item.usage}}</widget-value>
                </td>
                <td>
                  <widget-value [align]="'right'">{{item.areaPerUsage | rdLocalizedNumber:item.decimals}} {{item.unitOfLength}}{{item.isArea ? '²' : ''}}</widget-value>
                </td>
                <td></td>
                <td>
                  <widget-value *ngIf="item.unitOfLength !== 'units' && item.unitOfLength !== 'Units'" [align]="'right'">{{item.areaPerUsagePercentCalculated | rdLocalizedNumber:2}}{{'esgExteriorDescription.labelPercentOfTotalArea' | rdTranslate}}*</widget-value>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <table text-and-list-edit-mode class="lettable-area-table cellspacing-0 cellpadding-0" aria-hidden="true">
          <thead>
            <tr class="totalAreaRow">
              <th scope="col" class="textAlignLeft">{{'esgExteriorDescription.labelTotalArea' | rdTranslate}}</th>
              <th scope="col">
                <widget-value [align]="'right'">{{widgetData.lettableArea.split(' ')[0] | rdLocalizedNumber:0}} {{widgetData.lettableArea.split(' ')[1]}}</widget-value>
              </th>
              <th scope="col">&nbsp;</th>
              <th scope="col">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of widgetData['areaPerUsage']; let i = index;">
              <tr>
                <td>
                  <widget-value [align]="'left'">{{item.usage}}</widget-value>
                </td>
                <td>
                  <widget-value [align]="'right'">{{item.areaPerUsage | rdLocalizedNumber:item.decimals}} {{item.unitOfLength}}{{item.isArea ? '²' : ''}}</widget-value>
                </td>
                <td></td>
                <td>
                  <widget-value *ngIf="item.unitOfLength !== 'units' && item.unitOfLength !== 'Units'" [align]="'right'">{{item.areaPerUsagePercentCalculated | rdLocalizedNumber:2}}{{'esgExteriorDescription.labelPercentOfTotalArea' | rdTranslate}}*</widget-value>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </rd-textandlist-section>
      <tr>
        <td colspan="5">{{'esgExteriorDescription.labelRoundedRemark' | rdTranslate}}</td>
      </tr>
    </tbody>
  </table>
</div>
